let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("80ZnU")).then(() => parcelRequire('cNTqo'));